/*
  Koeln checkout redirect.
  Decides via SKU-prefix whether the cart should check out on dus.colognewatch.de.

  SKU convention (Cologne Watch):
    - AD*, KD*  -> Duesseldorf (Ankauf/Kommission DUS)
    - AK*, KK*  -> Koeln (Ankauf/Kommission Koeln)

  Cart policy: each cart contains exactly one product (enforced upstream).
  No Cloudways backend call; variant-id mapping happens on the DUS loading page
  via /products/<handle>.js using the SKU we pass through.
*/
$(document).ready(function () {
  // Escape-Hatch: Wenn eine URL explizit skip_redirect=1 setzt (z.B. aus dem DUS-Fallback
  // zurueck auf Koeln), soll kein weiterer Redirect-Check stattfinden - schuetzt gegen
  // hypothetische Koeln<->DUS Redirect-Loops bei Shopify-Verhaltensaenderungen.
  try {
    var __cw_params = new URLSearchParams(window.location.search);
    if (__cw_params.get("skip_redirect") === "1") {
      return;
    }
  } catch (e) {
    // URLSearchParams fehlt nicht in supported Browsers, aber defensiv.
  }

  var DUS_CHECKOUT_URL = "https://dus.colognewatch.de/pages/loading-page";
  var CHECKOUT_SELECTOR = ".cart__checkout-button, button[form='mini-cart-form']";
  var DUS_SKU_PREFIXES = ["AD", "KD"];

  var DECISION_LOADING = "loading";
  var DECISION_REDIRECT = "redirect";
  var DECISION_NORMAL = "normal";

  var decisionState = DECISION_LOADING;
  var redirectUrl = null;
  var redirectInProgress = false;
  var pendingButton = null;

  function getCookieValue(cookieName) {
    var prefix = cookieName + "=";
    var parts = document.cookie ? document.cookie.split("; ") : [];

    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return parts[i].substring(prefix.length);
      }
    }

    return null;
  }

  function isDusSku(sku) {
    if (!sku) {
      return false;
    }

    var upper = String(sku).trim().toUpperCase();
    for (var i = 0; i < DUS_SKU_PREFIXES.length; i += 1) {
      if (upper.indexOf(DUS_SKU_PREFIXES[i]) === 0) {
        return true;
      }
    }

    return false;
  }

  function buildRedirectUrl(dusItems) {
    var checkoutUrl = new URL(DUS_CHECKOUT_URL);

    $.each(dusItems, function (index, item) {
      if (!item) {
        return;
      }

      checkoutUrl.searchParams.append("h", item.handle);
      checkoutUrl.searchParams.append("sku", item.sku);
      checkoutUrl.searchParams.append("q", item.quantity);
      // Koeln-Variant-ID als Fallback-Info fuer DUS mitgeben.
      // Falls das DUS-SKU-Lookup scheitert (z.B. SKU-Tippfehler, Produkt nur in Koeln angelegt),
      // kann DUS damit direkt zum Koeln-Checkout-Permalink springen - User kauft trotzdem.
      if (item.koelnVariantId) {
        checkoutUrl.searchParams.append("kv", item.koelnVariantId);
      }
    });

    // ===== Tracking-Parameter für Cross-Domain Tracking =====
    var currentParams = new URLSearchParams(window.location.search);
    var trackingParams = [
      "fbclid",
      "gclid",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "_ga",
      "_gl",
    ];

    trackingParams.forEach(function (param) {
      var value = currentParams.get(param);
      if (value) {
        checkoutUrl.searchParams.append(param, value);
      }
    });

    // ===== Meta _fbc immer aus URL/Cookie weitergeben (Koeln -> DUS) =====
    var fbcFromUrl = currentParams.get("_fbc");
    var fbcValue = fbcFromUrl || getCookieValue("_fbc");
    if (fbcValue) {
      checkoutUrl.searchParams.append("_fbc", fbcValue);
    }

    // ===== Meta _fbp immer aus URL/Cookie weitergeben (Koeln -> DUS) =====
    var fbpFromUrl = currentParams.get("_fbp");
    var fbpValue = fbpFromUrl || getCookieValue("_fbp");
    if (fbpValue) {
      checkoutUrl.searchParams.append("_fbp", fbpValue);
    }
    // ===== Ende Tracking-Parameter =====

    return checkoutUrl.toString();
  }

  function setButtonsBusy(isBusy) {
    $(CHECKOUT_SELECTOR).prop("disabled", !!isBusy).attr("aria-busy", !!isBusy ? "true" : "false");
  }

  function continueWithNativeCheckout(buttonElement) {
    var formElement = null;

    if (buttonElement && buttonElement.form) {
      formElement = buttonElement.form;
    } else if (buttonElement) {
      formElement = $(buttonElement).closest("form").get(0);
    }

    if (formElement) {
      if (typeof formElement.requestSubmit === "function") {
        formElement.requestSubmit(buttonElement || null);
      } else {
        formElement.submit();
      }
      return;
    }

    var checkoutPath =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + "checkout"
        : "/checkout";

    window.location.href = checkoutPath;
  }

  function redirectToDusCheckout() {
    if (redirectInProgress) {
      return;
    }

    redirectInProgress = true;
    setButtonsBusy(true);

    if (!redirectUrl) {
      setButtonsBusy(false);
      redirectInProgress = false;
      continueWithNativeCheckout(pendingButton);
      return;
    }

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function () {
        window.location.href = redirectUrl;
      })
      .catch(function () {
        // Redirect trotzdem ausführen, damit der Checkout-Flow nicht hängen bleibt.
        window.location.href = redirectUrl;
      });
  }

  function loadDecision() {
    var deferred = $.Deferred();

    $.ajax({
      type: "GET",
      url: "/cart.json",
      cache: false,
    })
      .done(function (cartData) {
        var items = (cartData && cartData.items) ? cartData.items : [];

        // Defense: Cart-Policy sagt "immer genau 1 Artikel". Bei Policy-Verletzung (>1 Item)
        // brechen wir die Auto-Redirect-Logik ab, damit KEIN Item beim cart/clear.js verloren geht.
        // User landet im normalen Koeln-Checkout und Buchhaltung kriegt ggf. einen Grenzfall -
        // aber der Kunde verliert keinen Artikel.
        if (items.length > 1) {
          if (window.console && console.warn) {
            console.warn("localized-checkout: cart has", items.length, "items (expected 1); skipping redirect");
          }
          decisionState = DECISION_NORMAL;
          deferred.resolve();
          return;
        }

        var dusItems = [];

        $.each(items, function (index, item) {
          if (!item || !isDusSku(item.sku)) {
            return;
          }

          dusItems.push({
            handle: item.handle,
            sku: item.sku,
            quantity: item.quantity,
            koelnVariantId: item.id,
          });
        });

        if (dusItems.length > 0) {
          decisionState = DECISION_REDIRECT;
          redirectUrl = buildRedirectUrl(dusItems);
        } else {
          decisionState = DECISION_NORMAL;
        }

        deferred.resolve();
      })
      .fail(function () {
        // Ohne cart.json keine verlässliche Entscheidung - normalen Checkout zulassen.
        decisionState = DECISION_NORMAL;
        deferred.resolve();
      });

    return deferred.promise();
  }

  var decisionPromise = loadDecision();

  // Event delegation verhindert Timing-Probleme und deckt dynamische DOM-Updates ab.
  $(document)
    .off("click.localizedCheckout", CHECKOUT_SELECTOR)
    .on("click.localizedCheckout", CHECKOUT_SELECTOR, function (event) {
      if (redirectInProgress) {
        event.preventDefault();
        return;
      }

      if (decisionState === DECISION_REDIRECT) {
        event.preventDefault();
        pendingButton = this;
        redirectToDusCheckout();
        return;
      }

      if (decisionState === DECISION_NORMAL) {
        return;
      }

      // Entscheidung ist noch nicht fertig: Klick puffern und danach deterministisch fortsetzen.
      event.preventDefault();

      if (pendingButton) {
        return;
      }

      pendingButton = this;
      setButtonsBusy(true);

      decisionPromise.always(function () {
        var buttonToContinue = pendingButton;
        pendingButton = null;

        if (decisionState === DECISION_REDIRECT) {
          pendingButton = buttonToContinue;
          redirectToDusCheckout();
          return;
        }

        setButtonsBusy(false);
        continueWithNativeCheckout(buttonToContinue);
      });
    });
});
